import React from "react";

const HeaderTopbar = () => {
  return <></>;
};

export default HeaderTopbar;
